import { Button, styled } from '@mui/material'

export const StyledReportButton = styled(Button)(({ theme }) => ({
  padding: '2px 8px',
  marginLeft: 16,
  backgroundColor: theme.palette.error.dark,
  color: theme.palette.grey[50],
  boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.26)',
  minWidth: 'auto',
  borderRadius: 8,
  fontSize: theme.typography.caption.fontSize,
  '& svg': {
    color: theme.palette.grey[50]
  },
  '& .MuiButton-label': {
    justifyContent: 'center'
  },
  '&:hover, &:active': {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.common.white,
    '& svg': {
      color: theme.palette.common.white
    }
  },
  '& .admin': {
    backgroundColor: theme.palette.grey[800],
    color: theme.palette.warning.main,
    '& svg': {
      color: theme.palette.warning.main
    },
    '&:hover, &:active': {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.warning.main
    }
  }
}))
